module.exports = __webpack_public_path__ + "img/2021041920232654325c.faf72066.png";